import script from "./BarcodeGenerator.vue?vue&type=script&lang=js"
export * from "./BarcodeGenerator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__